import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Select  from 'react-select';
import logo from '../../../assets/Images/logo.png'
import './Registration.css';
// ==============================|| SIGN UP 1 ||============================== //

const SignUp1 = () => {

  const [fullName, setFullName] = useState('');
  const [username, setUsername] = useState('');
  const [loginName, setLoginName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [role, setRole] = useState('');
  const [roles, setRoles] = useState([]);
  const [errors, setErrors] = useState({});
const [focused, setFocused] = useState(false);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/role`)
      .then((response) => response.json())
      .then((data) => {
        const formatted = data.map(role => ({
           value: role.Role_NAME, // value should be role name string
          label: role.Role_NAME, 
        }))
        // Assuming the API returns an array of roles
        setRoles(formatted);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });
  }, []);

  const validate = () => {
    let errorMessages = {};

    if (!confirmPassword) {
      errorMessages.confirmPassword = "Confirm Password is required.";
    } else if (password !== confirmPassword) {
      errorMessages.confirmPassword = "Passwords do not match!";
    }

    // Required fields
  

    setErrors(errorMessages);
    return Object.keys(errorMessages).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!validate()) return;
  
    const registrationData = {
      userName: username,
      fullName: fullName,
      userLoginName: loginName,
      email: email,
      password: password,
      phoneNumber: phoneNumber,
      role: role.value, 
    };
  
    fetch(`${process.env.REACT_APP_API_BASE_URL}/api/register`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(registrationData),
    })
      .then(async (response) => {
        const contentType = response.headers.get("Content-Type");
  
        if (contentType && contentType.includes("application/json")) {
          return await response.json();
        } else {
          const text = await response.text();
          return { exDesc: text }; // ⬅️ Treat plain text as a fallback error
        }
      })
      .then((data) => {
        if (data.exCode) {
          switch (data.exCode) {
            case "EX0009":
              alert(`User already exists:
  Username: ${data.exDetails.userName}
  Email: ${data.exDetails.email}
  Phone: ${data.exDetails.phoneNumber}`);
              break;
            case "EX0001":
              alert("Full Name is required.");
              break;
            case "EX0002":
              alert("Username is already taken.");
              break;
            case "EX0003":
              alert("UserLogin Name already exists.");
              break;
            case "EX0004":
              alert("Email already exists.");
              break;
            case "EX0005":
              alert("Phone Number already exists.");
              break;
            default:
              alert(`Error: ${data.exDesc}`);
          }
        } else {
          // Success
          alert("🎉 Registration successful!");
  
          // Clear form
          setFullName('');
          setUsername('');
          setLoginName('');
          setEmail('');
          setPassword('');
          setConfirmPassword('');
          setPhoneNumber('');
          setRole('');
          setErrors({});
        }
      })
      .catch((error) => {
        console.error("Network error:", error);
        alert("Something went wrong during registration. Please try again.");
      });
  };
  

  return (
    <React.Fragment>
      {/* <Breadcrumb /> */}
      <div className="registration-container">
        <div className="registration-box">
                  <img src={logo} alt="" className="img-fluid mb-4" style={{ width: '50px', height: 'auto', margin: '10px', borderRadius: '50px', backgroundColor: 'white' }} />
                  <h4 className="registration-heading">Register</h4>
                  <form onSubmit={handleSubmit}>
                    <div className={`registration-floating-label-container ${fullName ? 'filled' : ''}`}>
                    <input type="text" id="fullName" value={fullName} onChange={(e) => setFullName(e.target.value)} required placeholder=" " />
                    <label htmlFor="fullName">Full Name</label>
                    {errors.fullName && <p className="error">{errors.fullName}</p>}
                  </div>
                    <div className={`registration-floating-label-container ${username ? 'filled' : ''}`}>
                    <input type="text" id="username" value={username} onChange={(e) => setUsername(e.target.value)} required placeholder=" " />
                    <label htmlFor="username">Username</label>
                    {errors.username && <p className="error">{errors.username}</p>}
                  </div>
                    <div className={`registration-floating-label-container ${loginName ? 'filled' : ''}`}>
                    <input type="text" id="loginName" value={loginName} onChange={(e) => setLoginName(e.target.value)} required placeholder=" " />
                    <label htmlFor="loginName">User Login Name</label>
                    {errors.loginName && <p className="error">{errors.loginName}</p>}
                  </div>
                    <div className={`registration-floating-label-container ${password ? 'filled' : ''}`}>
                    <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder=" " />
                    <label htmlFor="password">Password</label>
                    {errors.password && <p className="error">{errors.password}</p>}
                  </div>
                    <div className={`registration-floating-label-container ${confirmPassword ? 'filled' : ''}`}>
                    <input type="password" id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required placeholder=" " />
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    {errors.confirmPassword && <p className="error">{errors.confirmPassword}</p>}
                  </div>
                   <div className={`registration-floating-label-container ${email ? 'filled' : ''}`}>
                    <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder=" " />
                    <label htmlFor="email">Email Address</label>
                    {errors.email && <p className="error">{errors.email}</p>}
                  </div>
                   <div className={`registration-floating-label-container ${phoneNumber ? 'filled' : ''}`}>
                    <input type="tel" id="phoneNumber" value={phoneNumber}
                      maxLength={10}
                      onChange={(e) => {
                        const onlyNums = e.target.value.replace(/\D/g, '');
                        if (onlyNums.length <= 10) { setPhoneNumber(onlyNums); }
                      }}
                      required placeholder=" " />
                    <label htmlFor="phoneNumber">Phone Number</label>
                    {errors.phoneNumber && <p className="error">{errors.phoneNumber}</p>}
                  </div>

                    <div className={`registration-floating-label-container ${role ? 'filled' : ''} ${focused ? 'focused' : ''}`}>
                      <Select  id="role"
  options={roles}
  value={roles.find(r => r.value === role)}   // bind correctly
  onChange={(selected) => setRole(selected.value)}
                        onFocus={() => setFocused(true)}
                        onBlur={() => setFocused(false)}
                        required placeholder="" classNamePrefix="react-select"
                      />
                      <label htmlFor="role">Role</label>
                    </div>

                    <button className="btn btn-primary btn-block mb-4">Register</button>
                  </form>
                   {/*  <p className="mb-2"> Already have an account?{' '}
                  <NavLink to="/" className="f-w-400">Signin</NavLink> 
                  </p>*/}
              
            
        </div>
      </div>
    </React.Fragment>
  );
};

export default SignUp1;
